module.exports = __webpack_public_path__ + "static/media/arrows-alt.ae81cb54.svg";